import api from "./api.service";

/** Une chambre dans le classement d'audience. */
export interface ChambreStat {
  roomId: string;
  nom: string;
  vues: number;
  contacts: number;
  candidatures: number;
}

export interface Statistiques {
  periode: { debut: string; fin: string };
  /**
   * Date de la première vue jamais enregistrée pour cette colocation, ou
   * `null` si aucune. Indispensable à l'écran : la mesure a commencé bien
   * après les contacts et les candidatures, et sans cette date « 0 vue,
   * 4 contacts » se lit comme une panne plutôt que comme une absence de
   * mesure.
   */
  mesureDepuis: string | null;
  vues: { total: number; coloc: number; chambres: number };
  /**
   * Visiteurs distincts. Non cumulables au-delà de la journée : l'empreinte
   * change chaque nuit, donc un visiteur revenu deux jours compte deux fois.
   * L'écran doit le dire plutôt que de laisser croire à un total.
   */
  visiteurs: number;
  contacts: number;
  candidatures: number;
  chambres: ChambreStat[];
}

class StatistiquesService {
  async get(colocId: string, jours: number): Promise<Statistiques> {
    const response = await api.get(`/colocs/${colocId}/statistiques`, {
      params: { jours },
    });
    return response.data;
  }
}

export const statistiquesService = new StatistiquesService();
